export enum NotificationOptions {
    None = 1,
    Instant = 2,
    Weekly = 3,
    InstantAndWeekly = 4,
}
